import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const EyeStroked: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = '#83807F',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.9296 11.9778C18.78 11.7142 15.1842 5.5415 9.49995 5.5415C4.62241 5.5415 0.276089 11.6788 0.0932109 11.9404C-0.0310703 12.1187 -0.0310703 12.3803 0.0932109 12.5595C0.276089 12.8211 4.62241 18.9584 9.49995 18.9584C14.3775 18.9584 18.7238 12.8211 18.9067 12.5595C19.0215 12.3947 19.0318 12.156 18.9296 11.9778ZM9.49995 18.0001C5.58986 18.0001 1.87211 13.4862 0.927665 12.25C1.87055 11.0128 5.58433 6.49988 9.49995 6.49988C14.0751 6.49988 17.3043 11.007 18.0928 12.2241C17.1824 13.4211 13.4433 18.0001 9.49995 18.0001Z"
          fill={color}
        />
        <path
          d="M9.49996 8.4165C7.75353 8.4165 6.33325 10.1358 6.33325 12.2499C6.33325 14.364 7.75353 16.0833 9.49996 16.0833C11.2464 16.0833 12.6667 14.364 12.6667 12.2499C12.6667 10.1358 11.2464 8.4165 9.49996 8.4165ZM9.49996 15.125C8.19053 15.125 7.12492 13.835 7.12492 12.2499C7.12492 10.6648 8.19053 9.37488 9.49996 9.37488C10.8094 9.37488 11.875 10.6648 11.875 12.2499C11.875 13.835 10.8094 15.125 9.49996 15.125Z"
          fill={color}
        />
        <path
          d="M16.9143 2.13011C16.7417 1.9039 16.4612 1.9039 16.2887 2.13011L1.24708 21.8516C1.07454 22.0778 1.07454 22.4456 1.24708 22.6718C1.3338 22.7843 1.44703 22.8412 1.5603 22.8412C1.67357 22.8412 1.78679 22.7843 1.87265 22.6718L16.9143 2.95031C17.0868 2.72409 17.0868 2.35633 16.9143 2.13011Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default EyeStroked;
